
<div class="unh-modal-body">
 
  <div class="modal-modal-card">
     <a [mat-dialog-close]="true"
      class="unh-modal-close">
      <img 
        class="times-ico" 
        src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/ico-close.png" 
        alt="Close modal">
    </a>

    <h3 *ngIf="editProfile">
      Alterar Cartão
    </h3>
    
        <div class="retry-message"
      *ngIf="(!editProfile && tryAgain) || errorPayment">
      <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/emoji/emoji-sad.svg" 
        alt="">
      
      <h3>
        OPS!
      </h3>
  
      <h4>
        A cobrança no seu cartão foi recusada novamente. =(<br>
        Entre em contato com a sua operadora,<br>
        ou cadastre um novo cartão para nova tentativa!
      </h4>
    </div>

    <div class="card-box">
      <div class="card-content">
        <div class="info-line text-right">
          <img
            class="flag-img"
            [src]="'https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/card-flags/' + cardTypeData?.type + '.png'" 
            [alt]="cardTypeData?.niceType">
        </div>
  
        <div class="info-line">
          <span class="card-number-container">
            {{ isTyping? cNumber_1: card_number_first_four}}
          </span>
          <span class="card-number-container">
            {{ isTyping? cNumber_2: '&bull; &bull; &bull; &bull;'}}
          </span>
          <span class="card-number-container">
            {{ isTyping? cNumber_3: '&bull; &bull; &bull; &bull;'}}
          </span>
          <span class="card-number-container">
            {{ isTyping? cNumber_4: paymentProfile.card_number_last_four}}
          </span>
        </div>
  
        <div flex class="info-line">
          <div class="titular">
            <span>titular</span>
            <h5>
              {{partialData?.holder_name}}
            </h5>
          </div>
  
          <div class="validade">
            <span>val.</span>
            <h5>
              {{partialData?.exp_month}}
              <ng-container *ngIf="partialData?.exp_month || partialData?.exp_year">/</ng-container>
              {{partialData?.exp_year}}
            </h5>
          </div>
        </div>
      </div>
    </div>


  
    <unh-form-credit-card
      [btn_text]="(editProfile && !tryAgain)? 
        'Trocar perfil de pagamento' : 'Pagar com novo cartão'"
      (onSubmit)='paymentRetryNewData($event)'
      (partialData)='fillCard($event)'
      [isSubmitting]="isLoading"
    ></unh-form-credit-card>
  </div>
</div>

